import React from "react";
import PharmacyTabs from "./PharmacyTabs";

function PharmacyInvoice() {
  return (
    <>
      <div className="flex flex-col gap-3 h-[94%]">
        <div className="h-full">
          PharmacyInvoice
        </div>
      </div>
    </>
  );
}

export default PharmacyInvoice;